<template>
	<div class="list">
		<monthly-product-search ref="productSearch" @submit="getSearch" />
		<div class="list__header">
			<div class="list__header__count">
				등록: {{ count.totalCount || 0 }} | 활성:
				{{ count.displayCount || 0 }} | 비활성:
				{{ count.unDisplayCount || 0 }}
			</div>
			<router-link
				to="/product/monthly-product/register"
				class="btn blue list__header__register-btn"
			>
				등록
			</router-link>
		</div>

		<table class="list__table table-main">
			<thead>
				<tr>
					<th>항번</th>
					<th>브랜드명</th>
					<th>제품명</th>
					<th>시작일</th>
					<th>종료일</th>
					<th>상태</th>
					<th>수정</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="product in getProducts"
					:key="product.idMonthlyProduct"
				>
					<td>
						<router-link
							class="list__table__link"
							:to="`/product/monthly-product/edit/${product.idMonthlyProduct}`"
						>
							{{ product.idMonthlyProduct }}
						</router-link>
					</td>
					<td>{{ product.brandTitle }}</td>
					<td>
						<router-link
							class="list__table__link"
							:to="`/product/product-inquiry/${product.idProduct}`"
						>
							{{ product.productTitle }}
						</router-link>
					</td>
					<td>{{ product.startDate }}</td>
					<td>{{ product.endDate }}</td>
					<td style="width: 120px">
						<toggleswitch-box
							@changingVal="
								onToggleClick(product.idMonthlyProduct, $event)
							"
							:checkSts="product.isDisplay"
							:checkObj="{ value: true, text: '활성' }"
							:unCheckObj="{ value: false, text: '비활성' }"
						/>
					</td>
					<td>
						<button
							class="btn blue"
							@click="onModifyClick(product.idMonthlyProduct)"
						>
							수정
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="list__pagination">
			<pagination-box
				:totalItem="total"
				:limit="limit"
				:offset="offset"
				:pageLengPerOne="10"
				@to="onPaging"
			/>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	import find from 'lodash/find';
	import isEqual from 'lodash/isEqual';
	import { stringify } from 'query-string';
	import MonthlyProductSearch from '@/components/product/MonthlyProductSearch';
	import ToggleswitchBox from '@/components/ToggleswitchBox';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'MonthlyProductList',
		components: {
			MonthlyProductSearch,
			ToggleswitchBox,
			PaginationBox,
		},
		data() {
			return {
				limit: 10,
				offset: 0,
				total: 0,
				count: {
					displayCount: 0,
					totalCount: 0,
					unDisplayCount: 0,
				},
				products: [],
			};
		},
		watch: {
			'$route.query': {
				immediate: true,
				handler(query) {
					this.getList();
					this.$nextTick(() => {
						this.$refs.productSearch.setSearchArgs(query);
					});
				},
			},
		},
		computed: {
			getProducts() {
				return this.products;
			},
		},
		methods: {
			getSearch(args) {
				const query = Object.keys(args).reduce((acc, key) => {
					if (args[key]) {
						acc[key] = args[key].toString();
					}
					return acc;
				}, {});
				query.offset = '0';

				if (isEqual(this.$route.query, query)) {
					this.getList();
				} else {
					this.$router.push({
						query,
					});
				}
			},
			getList() {
				const params = this.$route.query;
				const offset = Number(params.offset);
				this.offset = !isNaN(offset) ? Number(offset) : 0;

				this.$axiosAdmin2
					.get('/api/products/monthly', { params })
					.then(({ data }) => {
						this.count = data.monthlyProductCount;
						this.products = data.monthlyProducts.data.map(
							product => {
								product.startDate = this.convertDateFormat(
									product.startDate
								);
								product.endDate = this.convertDateFormat(
									product.endDate
								);

								return product;
							}
						);
						this.total = data.monthlyProducts.contentTotal;
					})
					.catch(err => {
						console.error(err);
						alert(
							'인기 신제품 리스트를 불러오지 못했습니다.\n개발팀에 문의하세요'
						);
					});
			},
			onToggleClick(idMonthlyProduct, { value }) {
				const query = {
					idMonthlyProduct,
					isDisplay: value,
				};

				this.$axiosAdmin2
					.put(`/api/products/monthly/isdisplay?${stringify(query)}`)
					.then(() => {
						find(this.products, { idMonthlyProduct }).isDisplay =
							value;
					})
					.catch(err => {
						console.error(err);
						alert(
							'상태 정보 업데이트에 실패했습니다.\n개발팀에 문의하세요'
						);
					});
			},
			onPaging({ offset }) {
				this.offset = Number(offset);
				this.$router.push({
					query: {
						...this.$route.query,
						offset: this.offset,
					},
				});
			},
			onModifyClick(id) {
				const queries = btoa(
					encodeURIComponent(JSON.stringify(this.$route.query))
				);
				const path = `/product/monthly-product/edit/${id}`;

				this.$router.push({
					path,
					query: { back: queries },
				});
			},
			convertDateFormat(date) {
				return moment(date, 'YYYYMMDDHHmmss').format(
					'YYYY-MM-DD HH:mm'
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.list__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 1em;
	}

	.list__header__register-btn {
		display: block;
	}

	.list__header__count {
		display: block;
		padding: 1em 1em;
		margin: 1em 0;
		background: #dfe6ee;
		color: #657088;
		font-size: 1rem;
		font-weight: bold;
		border-radius: 2em;
	}

	.list__table__link {
		color: $btn-blue;
		text-decoration: underline;
		font-weight: bold;
	}

	.list__pagination {
		padding: 1em 0;
	}
</style>
